/* eslint-disabled */

export default class VoucherExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
